$(document).ready(function() {

    var configObj = $('.ttgStaticMapDetail');

    if (configObj.attr('data-mapsLicense') == 1) {
        configObj.css("cursor", "pointer");
    } else {
        // bei keiner Lizenz darf die Map nicht in einem Modal geöffnet werden
        return;
    }

    // MAPS Hash Wert bei einer Tour laden
    if (configObj.attr('data-metaSourceCategory') == 'Tour' && configObj.attr('data-sourceId') > 0) {
        var metaURL = window.location.protocol + "//" + window.location.host + "/?type=1830";
        $.ajax({
            method: 'POST',
            url: metaURL,
            dataType: 'jsonp',
            data: 'experience=' + configObj.attr('data-mapsConfig') + '&type=Tour&limit=1&mkt=' + $('html').attr("lang") + '&q=sourceid:' + configObj.attr('data-sourceId') + '&template=ET2014A.json&sort=',
            success: function(res) {
                if (res.overallcount == 1) {
                    configObj.attr("data-metaHash", res.items[0].global_id);
                }
            }
        });
    }

    var sourceId = 0;
    // Bei Klick auf den Karte-Button, das Modal öffnen
    $('.ttgStaticMapDetail').click(function() {
        // reset sourceId
        sourceId = 0;
        $('#ttgMapModalDetail').modal('show');
    });

    // Iframe Höhe beim Resizen anpassen
    $(window).bind("resize", function(e) {
        if ($("#ttgModalMapIframe").length > 0 && $('#ttgMapModalDetail').length > 0) {
            var mh = $("#ttgMapModalDetail .modal-dialog").height();
            mh = parseInt(mh) - 200;
            $("#ttgModalMapIframe").css("height", mh + 'px');
        }
    });

    $('#ttgMapModalDetail').on('shown.bs.modal', function() {

        var configObj = $('.ttgStaticMapDetail');

        // Parameter für den Iframe
        var getParams = "&no_cache=1";
        // wenn der Aufruf von der Detailseite kam
        if (configObj.attr("data-metaSourceCategory")) {
            getParams += "&type=" + configObj.attr("data-metaSourceCategory");
            getParams += "&show=detail";
        }

        if (configObj.attr("data-sourceCategory")) {
            getParams += "&sourceCategory=" + configObj.attr("data-sourceCategory");
        }

        if (configObj.attr("data-sourceId")) {
            getParams += "&sourceId=" + configObj.attr("data-sourceId");
        }

        if (configObj.attr("data-relations")) {
            getParams += "&show=relations&pins=" + configObj.attr("data-relations");
        }

        if (sourceId > 0) {
            getParams += "&detailPinSourceId=" + sourceId;
        }

        if (configObj.attr("data-lat") && configObj.attr("data-lon")) {
            getParams += "&lat=" + configObj.attr("data-lat") + "&lon=" + configObj.attr("data-lon");
        }

        if (configObj.attr("data-baseDomain")) {
            // get rid of cHash
            getParams += "&baseDomain=" + configObj.attr("data-baseDomain").split("&cHash")[0];
        }

        if (configObj.attr("data-metaHash")) {
            getParams += "&metaHash=" + configObj.attr("data-metaHash");
        }

        // aktuelle Sprache übergeben
        if (configObj.attr("data-lang")) {
            getParams += "&lang=" + configObj.attr("data-lang");
        }

        // Detailseite
        if (configObj.attr("data-mapsConfig")) {
            getParams += "&mapsConfig=" + configObj.attr("data-mapsConfig");
        }

        // kein Info-Fenster beim Pin Laden
        if (configObj.attr("data-mapsNoInfoWindow")) {
            getParams += "&noInfoWindow=" + configObj.attr("data-mapsNoInfoWindow");
        }

        if (getCookie('cookieConsented-analysis')) {
            getParams += "&consent-analysis=" + getCookie('cookieConsented-analysis');
        }

        getParams += "&d=" + Date.now();
        var modalHeight = $("#ttgMapModalDetail .modal-dialog").height();
        modalHeight = parseInt(modalHeight) - 100;
        setTimeout(function() {
            var iFrameURL = '<iframe id="ttgModalMapIframe" src="' + configObj.attr('data-mapsModalIframeURL') + getParams + '" border="0" style="height: ' + modalHeight + 'px;"></iframe>';
            $("#ttgModalMapDetailWrapper").html(iFrameURL);
        }, 50);
    });

});